import { compose } from 'redux'
import { connect } from 'react-redux'
import { doShowTicketPreviewModal } from 'actions/modals'
import View from './view'

const perform = {
  showTicketPreviewModal: doShowTicketPreviewModal,
}

export default compose(connect(null, perform), View)
